import {
	ICatalogue,
	ICatalogueCustomization,
	ICatalogueCustomizationsOptions,
	ICatalogueSetItem,
} from "../../../../apis/useGetCatalogueData/types";

export const createCatalogueMap = (products: ICatalogue[]): Map<string, ICatalogue> => {
	const map = new Map<string, ICatalogue>();

	for (const product of products) {
		map.set(product.id, product);
	}

	return map;
};

export const hasOosCustomization = (
	customizations: ICatalogueCustomization[] | undefined | null,
	catalogueMap: Map<string, ICatalogue>
): boolean => {
	if (!customizations) return false;

	return customizations.some((customization) => {
		const options = customization.food_supplier_customization_options;

		if (!options) return false;

		return options.some((option: ICatalogueCustomizationsOptions) => {
			if (!option.quantity || option.quantity === 0) return false;

			return option.available === false;
		});
	});
};

export const hasOosSetItem = (
	setItems: ICatalogueSetItem[] | undefined | null,
	catalogueMap: Map<string, ICatalogue>
): boolean => {
	if (!setItems) return false;

	return setItems.some((setItem) => {
		const setItemId = String(setItem.food_supplier_menu_item_id);
		const catalogueSetItem = catalogueMap.get(setItemId);

		if (!catalogueSetItem) return true;

		if (catalogueSetItem.inventory_count === 0) return true;

		return hasOosCustomization(setItem.food_supplier_customizations, catalogueMap);
	});
};

export const isItemOos = (item: ICatalogue, catalogueMap: Map<string, ICatalogue>): boolean => {
	const catalogueItem = catalogueMap.get(item.id);

	if (!catalogueItem) return true;

	if (catalogueItem.inventory_count === 0) return true;

	if (hasOosSetItem(item.food_supplier_set_items, catalogueMap)) return true;

	return hasOosCustomization(item.food_supplier_customizations, catalogueMap);
};

export const getOosItems = (
	cart: ICatalogue[],
	catalogueMap: Map<string, ICatalogue>
): ICatalogue[] => {
	return cart.filter((item) => isItemOos(item, catalogueMap));
};

export const getOosSetItemNames = (
	setItems: ICatalogueSetItem[] | undefined | null,
	catalogueMap: Map<string, ICatalogue>
): string[] => {
	if (!setItems) return [];

	const oosSetItemNames: string[] = [];

	for (const setItem of setItems) {
		const setItemId = String(setItem.food_supplier_menu_item_id);
		const catalogueSetItem = catalogueMap.get(setItemId);

		if (!catalogueSetItem || catalogueSetItem.inventory_count === 0) {
			oosSetItemNames.push(setItem.title);
		}
	}

	return oosSetItemNames;
};

export interface IOosItemDetail {
	title: string;
	unavailableItems?: string[];
}

export const getOosItemDetails = (
	oosItems: ICatalogue[],
	catalogueMap: Map<string, ICatalogue>
): IOosItemDetail[] => {
	return oosItems.map((item) => {
		const oosSetItemNames = getOosSetItemNames(item.food_supplier_set_items, catalogueMap);

		if (oosSetItemNames.length > 0) {
			return {
				title: item.title,
				unavailableItems: oosSetItemNames,
			};
		}

		return {
			title: item.title,
		};
	});
};

export const getOosItemNames = (oosItems: ICatalogue[]): string[] => {
	return oosItems.map((item) => item.title);
};

export const filterOutOosItems = (
	cart: ICatalogue[],
	catalogueMap: Map<string, ICatalogue>
): ICatalogue[] => {
	return cart.filter((item) => !isItemOos(item, catalogueMap));
};
